<template>
  <div>
    <el-form ref="form" :model="formData" :rules="rules">
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item
            :label="$l('form_label_name_cn') || '中文名称'"
            prop="scmAttributeName"
          >
            <el-input
              v-model="formData.scmAttributeName"
              maxlength="100"
              :placeholder="$l('INDEX.tips_no_data') || '暂无数据'"
              :disabled="isViewDisabled"
              clearable
              size="medium"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            :label="$l('form_label_name_en') || '英文名称'"
            prop="scmAttributeNameEn"
          >
            <el-input
              v-model="formData.scmAttributeNameEn"
              maxlength="100"
              :placeholder="$l('INDEX.tips_no_data') || '暂无数据'"
              :disabled="isViewDisabled"
              clearable
              size="medium"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            :label="$l('form_label_attribute_type') || '属性类型'"
            prop="scmAttributeType"
          >
            <el-input
              v-model="formData.scmAttributeType"
              maxlength="50"
              :placeholder="$l('INDEX.tips_no_data') || '暂无数据'"
              :disabled="isViewDisabled"
              clearable
              size="medium"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            :label="$l('form_label_status') || '状态'"
            prop="scmAttributeStatus"
          >
            <el-radio-group
              style="width: 100%"
              size="medium"
              disabled
              v-model="formData.scmAttributeStatus"
            >
              <el-radio label="Y">{{
                $l('form_radio_valid') || '有效'
              }}</el-radio>
              <el-radio label="N">{{
                $l('form_radio_invalid') || '无效'
              }}</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item
            :label="$l('form_label_attribute_desc') || '属性说明'"
            prop="scmAttributeDescription"
          >
            <el-input
              type="textarea"
              :disabled="isViewDisabled"
              :rows="3"
              v-model="formData.scmAttributeDescription"
              maxlength="2000"
              clearable
              size="medium"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col v-if="createDataDisabled">
          <div style="font-size: 14px; color: #717171;">
            <span
              >Create：{{
                formData.createByName ? formData.createByName : '--'
              }}
              at {{ formData.createDate ? formData.createDate : '--' }}</span
            >
          </div>
          <div style="font-size: 14px; color: #717171;">
            <span
              >Modify：{{
                formData.modifyByName ? formData.modifyByName : '--'
              }}
              at {{ formData.modifyDate ? formData.modifyDate : '--' }}</span
            >
          </div>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
export default {
  data() {
    return {
      createDataDisabled: false,
      isViewDisabled: false,
      formData: {
        scmAttributeCode: '',
        scmAttributeName: '', // 中文名称
        scmAttributeNameEn: '', // 英文名称
        scmAttributeStatus: '', // 有效状态
        scmAttributeType: '', // 属性类型
        scmAttributeDescription: '', // 属性说明
        createByName: '', // 创建人
        createDate: '', // 创建时间
        modifyByName: '', // 修改人
        modifyDate: '' // 修改时间
      },
      rules: {
        scmAttributeName: [
          { required: true, message: '请输入中文名称', trigger: 'blur' }
        ],
        scmAttributeType: [
          { required: true, message: '请输入属性类型', trigger: 'blur' }
        ],
        scmAttributeDescription: [
          { required: true, message: '请输入属性说明', trigger: 'blur' }
        ],
        scmAttributeNameEn: [
          { required: true, message: '请输入英文名称', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    // 初始化表单数据
    init() {
      this.isViewDisabled = false
      this.reset()
    },
    // 加载表单数据（新增，编辑，详情）
    fromLoad(ref, val = '') {
      this.init()
      if (ref !== 'add') {
        this.createDataDisabled = false
        let param = { scmAttributeCode: val }
        this.$api.scmDictionaryDetailApi(param).then((res) => {
          this.formData = res.body
        })
        // 控制组件不可编辑
        if (ref === 'detail') {
          this.isViewDisabled = true
          this.createDataDisabled = true
        }
      } else {
        this.createDataDisabled = false
        this.formData.scmAttributeStatus = 'Y'
      }
    },
    // 保存数据
    save() {
      // 校验表单正确性
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$api.scmDictionarySaveApi(this.formData).then(() => {
            this.$message({
              showClose: true,
              message: this.$l('INDEX.tips_save_ok') || '保存成功',
              type: 'success'
            })
            // 通知父组件保存成功
            this.$emit('success')
          })
        } else {
          return false
        }
      })
    },
    reset() {
      this.formData = {
        scmAttributeCode: '',
        scmAttributeName: '', // 中文名称
        scmAttributeNameEn: '', // 英文名称
        scmAttributeStatus: '', // 有效状态
        scmAttributeType: '', // 属性类型
        scmAttributeDescription: '', // 属性说明
        createByName: '', // 创建人
        createDate: '', // 创建时间
        modifyByName: '', // 修改人
        modifyDate: '' // 修改时间
      }
      this.$refs.form.resetFields()
    }
  }
}
</script>
